import { render, staticRenderFns } from "./CRUDCategoriasTickets.vue?vue&type=template&id=2727791b&"
import script from "./CRUDCategoriasTickets.vue?vue&type=script&lang=js&"
export * from "./CRUDCategoriasTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports